import React, { useEffect } from "react";
import { FlexColumn, FlexRow } from "@/ui/FlexContainer/FlexContainer";
import Typography from "@/ui/Typography/Typography";
import { ArrowIcon } from "@/assets/icons";
import { useParams, useNavigate } from "react-router-dom";
import { useCurrentRefProgramStore } from "@/store/currentRefProgram";
import { getRefProgramById } from "@/api/base";
import { InstructionBlock } from "@/components/InstructionBlock/InstructionBlock";
import { parsDate, declinateOrders } from "@/utils/helpers";
import ContainerLoader from "@/ui/ContainerLoader/ContainerLoader";
import { useUserInfoStore } from "@/store/userInfoStore";
import { InviteFriendBlock } from "@/components/InviteFriend/InviteFriendBlock";
import cls from "./styles.module.scss";

export const RefProgramPage = () => {
  const navigate = useNavigate();
  const yandexId = useUserInfoStore((state) => state.yandexId);
  const currentRefProgram = useCurrentRefProgramStore(
    (s) => s.currentRefProgram
  );
  const setCurrentRefProgram = useCurrentRefProgramStore(
    (s) => s.setCurrentRefProgram
  );
  const { id } = useParams<{ id: string }>();

  const loadData = async () => {
    if (!id) return;

    try {
      const res = await getRefProgramById(id, yandexId);
      setCurrentRefProgram(res);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (!id) return;
    setCurrentRefProgram(null);

    loadData();
  }, [id]);

  if (!currentRefProgram) return <ContainerLoader />;

  return (
    <FlexColumn gap={28}>
      <div className={cls.header}>
        <button
          type="button"
          data-trigger="ref.conditions.detail_back"
          className={cls.backBtn}
          onClick={() => navigate(-1) ?? navigate("/conditions")}
        >
          <ArrowIcon />
        </button>
        <Typography variant="h4">{currentRefProgram?.tariff}</Typography>
      </div>

      <FlexColumn gap={20}>
        <FlexColumn gap={18} className={cls.referalCard}>
          <FlexRow justifyContent="space-between" alignItems="flex-start">
            <FlexColumn gap={0}>
              <Typography className={cls.refTitle}>
                Условия действуют
              </Typography>
              <Typography className={cls.refDesc}>
                {parsDate(
                  currentRefProgram?.msk_start_date,
                  currentRefProgram?.msk_end_date
                )}
              </Typography>
            </FlexColumn>
          </FlexRow>

          <FlexColumn gap={14}>
            {currentRefProgram?.conditions?.map((elem, index) => (
              <FlexRow key={elem.id} justifyContent="space-between">
                <FlexRow gap={12}>
                  <div className={cls.circle}>
                    {index < currentRefProgram?.conditions.length - 1 && (
                      <div className={cls.connectCirclesBlock} />
                    )}
                  </div>
                  <Typography className={cls.activeStep}>
                    +{elem.step_1_amount} рублей
                  </Typography>
                </FlexRow>
                <Typography className={cls.step}>
                  {declinateOrders(elem?.rides_amount || 0)}
                </Typography>
              </FlexRow>
            ))}
          </FlexColumn>
        </FlexColumn>

        <InstructionBlock />

        <InviteFriendBlock
          variant={currentRefProgram?.service_type || "delivery"}
          inConditions
        />
      </FlexColumn>
    </FlexColumn>
  );
};
